// extracted by mini-css-extract-plugin
export var arrow = "menu-module--arrow--he3BG";
export var menu = "menu-module--menu--6YNKK";
export var stickyMenu = "menu-module--stickyMenu--ewuO9";
export var item = "menu-module--item--SGBPM";
export var list = "menu-module--list--+MQt4";
export var link = "menu-module--link--ar+Rp";
export var socialLinks = "menu-module--socialLinks--WfnVH";
export var socialLink = "menu-module--socialLink--ksPDH";